import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=349bf4e7&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/usr/src/motec/components/PageHeader.vue').default,ShowcaseCard: require('/usr/src/motec/components/showcase/Card.vue').default})
